import 'regenerator-runtime/runtime';
import './monitoring';
import './polyfills';
import './auth';
import { polyfillTimezones, shouldApplyPolyfillTimezone } from '@lingoda/i18n';
import { isRequirePolyfillTimezonesTest } from '@lingoda/local-feature-flags';
import { getLang, toUrlLang } from '@lingoda/env';

const initApplication = async () => {
    const lang = getLang();
    const polyfillLang = toUrlLang(lang);
    window.document.documentElement.lang = lang;

    const [{ startApplication }] = await Promise.all([
        await import('./app'),
        import(`./locale/${lang}.ts`),
        ...(shouldApplyPolyfillTimezone() || isRequirePolyfillTimezonesTest()
            ? [polyfillTimezones(polyfillLang)]
            : []),
    ]);

    startApplication();
};

(function () {
    void initApplication();
})();
